var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('app-modal',{attrs:{"name":"report-statistics-modal","hide-title":"","title":_vm.title,"hide-footer":""},on:{"before-open":_vm.beforeOpen,"before-close":_vm.beforeClose,"on-ok":_vm.onOk}},[_c('report-statistics',{attrs:{"directories":_vm.directories,"tag":_vm.tag}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-26ce4e59","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/portal-components/report/report-statistics-modal.vue
// module id = zvhB
// module chunks = 23